import Cassiq from "@/views/serigy/Cassiq.vue"
import Invoker from "@/views/serigy/Invoker.vue"
import AvaliacaoGeral from "@/views/serigy/AvaliacaoGeral.vue"
import UgSerigy from "@/views/serigy/UgSerigy.vue"


const serigyRotas = [
  {
    path: "/serigy/cassiq",
    name: "serigy-cassiq",
    component: Cassiq,
  },
  {
    path: "/serigy/invoker",
    name: "serigy-invoker",
    component: Invoker,
  },
  {
    path: "/serigy/avaliacao-geral",
    name: "serigy-avaliacao-geral",
    component: AvaliacaoGeral,
  },  
  {
    path: "/serigy/hash-ug",
    name: "serigy-hash-ug",
    component: UgSerigy,
  }

];

export { serigyRotas };
